import React, { useState, useEffect } from 'react';
import { ArrowUpDown } from 'lucide-react';
import ReviewCard from './ReviewCard';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ReviewsGrid = ({ initialReviews }) => {
  const [reviews, setReviews] = useState(initialReviews);
  const [filteredReviews, setFilteredReviews] = useState(initialReviews);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('recent');

  const categories = [
    { value: 'all', label: 'All' },
    { value: 'Glass Balustrades', label: 'Glass Balustrades' },
    { value: 'Pool Fencing Installation', label: 'Pool Fencing' },
    { value: 'Glass Pool Fencing', label: 'Glass Pool Fencing' }
  ];

  // Fetch user-submitted reviews from backend
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/reviews`);
        const userReviews = response.data;
        // Combine hipages reviews with user reviews
        setReviews([...initialReviews, ...userReviews]);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      }
    };
    fetchReviews();
  }, [initialReviews]);

  // Apply filters and sorting
  useEffect(() => {
    let result = [...reviews];

    // Filter by category
    if (selectedCategory !== 'all') {
      result = result.filter(
        (review) => (review.category || review.job_type) === selectedCategory
      );
    }

    // Sort
    if (sortBy === 'recent') {
      result.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA;
      });
    } else if (sortBy === 'highest') {
      result.sort((a, b) => b.rating - a.rating);
    }

    setFilteredReviews(result);
  }, [reviews, selectedCategory, sortBy]);

  return (
    <div className="reviews-grid-container">
      <div className="reviews-controls">
        <div className="filter-chips">
          {categories.map((cat) => (
            <button
              key={cat.value}
              className={`filter-chip ${selectedCategory === cat.value ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.value)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        <div className="sort-dropdown">
          <ArrowUpDown size={16} />
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="recent">Most recent</option>
            <option value="highest">Highest rated</option>
          </select>
        </div>
      </div>

      <div className="reviews-grid">
        {filteredReviews.map((review) => (
          <ReviewCard key={review.id} review={review} showCategory={true} />
        ))}
      </div>

      {filteredReviews.length === 0 && (
        <p className="no-reviews">No reviews found for this category.</p>
      )}
    </div>
  );
};

export default ReviewsGrid;
